import React, { ChangeEvent, FunctionComponent } from 'react';

import { FormControlElementProps } from '../Form.constants';
import RadioInputs, { RadioInputsOption } from '../../RadioInputs';

type ToggleFieldProps = {
  control: FormControlElementProps;
  inputChangedHandler: (name: string, value: string) => void;
};

const RadioInputsField: FunctionComponent<ToggleFieldProps> = ({ control, inputChangedHandler }) => {
  const { id, error, fieldType, label, options, required, touched, valid, validations, value, ...elementProps } =
    control;

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = event.target;
    inputChangedHandler(name, value);
  };

  return (
    <div key={`${fieldType}-${id}`}>
      <RadioInputs
        {...elementProps}
        id={id}
        value={value as string}
        required={required || !!validations?.required}
        title={label}
        options={(options as RadioInputsOption[]) || []}
        error={touched && !valid ? error : ''}
        onChange={handleOnChange}
      />
    </div>
  );
};

export default RadioInputsField;
